import { render, staticRenderFns } from "./TroubleshootZh.vue?vue&type=template&id=284a60f8&scoped=true&"
import script from "./TroubleshootZh.vue?vue&type=script&lang=js&"
export * from "./TroubleshootZh.vue?vue&type=script&lang=js&"
import style0 from "./TroubleshootZh.vue?vue&type=style&index=0&id=284a60f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284a60f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCardText,VDivider})
